import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { tokens } from "../../../theme";
import { DateOnlyFormatter } from "../../../helpers/formatters";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../api/main/appStore";
import ModalDecisionContent from "../../shared/modal/ModalDecisionContent";
import { Button } from "@mui/material";
import { ApprovalOutlined, LockOutlined } from "@mui/icons-material";
import { ManualTransferModel } from "../../../api/models/manualTransfer";
import DocumentLink from "../../shared/document-link/DocumentLink";
import ConfirmTransferForm from "../transfers/ConfirmTransferForm";

interface Props {
  data: ManualTransferModel[];
}

const columns = ["Financier", "Date Sent", "Receipt", " "];

export default observer(function UnconfirmedTransferTable({ data }: Props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const colors = tokens();

  const { commonStore, manualTransferStore } = useStore();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleConfirmClick = (transfer: ManualTransferModel) =>
    commonStore.setModalContent(
      <ConfirmTransferForm transfer={transfer} />,
      ""
    );

  const handleDeleteClick = (transfer: ManualTransferModel) =>
    commonStore.setModalContent(
      <ModalDecisionContent
        actionName={`delete ${transfer.financierName}'s transfer record named ${transfer.fileName}`}
        actionCallback={() =>
          manualTransferStore.deleteManualTransfer(transfer.id)
        }
      />,
      ""
    );

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                "& .MuiTableCell-head": {
                  color: `${colors.grey[600]}`,
                  fontWeight: "bolder",
                },
              }}
            >
              {columns.map((column, index) => (
                <TableCell key={index} align="left" style={{ maxWidth: 100 }}>
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <TableCell>{row.financierName}</TableCell>
                    <TableCell>{DateOnlyFormatter(row.dateModified)}</TableCell>
                    <TableCell>
                      <DocumentLink
                        fileUrl={row.reciept}
                        fileName={row.fileName}
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        color="success"
                        startIcon={<ApprovalOutlined />}
                        onClick={() => handleConfirmClick(row)}
                      >
                        Confirm
                      </Button>

                      <Button
                        size="small"
                        color="error"
                        onClick={() => handleDeleteClick(row)}
                      >
                        Remove
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
});
